<template>
    <div>
        <veui-dialog
            title="税务代办服务说明"
            :closable="true"
            :open="showTaxDialog"
            overlay-class="tax-dialog"
            @cancel="closeTaxDialog"
        >
            <div class="tax-dialog-content">
                <p>根据相关法律法规要求，平台需为您代办增值税及附加税的申报缴纳事宜，请您仔细阅读并确认以下授权内容：</p>
                <p>1. 授权范围：平台将依法为您代办增值税及附加税的计算、申报、缴纳等相关税务事宜。</p>
                <p>2. 授权说明：此授权仅用于本次及后续您在本平台提现相关的税务代办服务，严格保护您的个人信息及数据安全，且相关代办凭证将按规定留存备份。</p>
                <div class="tips">
                    如您同意《税务代办服务说明》，请点击同意按钮，平台后续将依法为您代办增值税及附加税
                </div>
            </div>
            <template #foot>
                <veui-button ui="l primary" @click="clickAgree">
                    我已阅读并同意
                </veui-button>
            </template>
        </veui-dialog>

        <!-- 同意确认二次弹窗 -->
        <veui-dialog
            title="已同意税务代办服务说明"
            :closable="true"
            :open="showConfirmDialog"
            overlay-class="tax-dialog"
            @cancel="closeConfirmDialog"
        >
            <div class="tax-dialog-content">
                <div>您已确认《税务代办服务说明》，后续平台将依法为您代办增值税及附加税的计算、申报、缴纳等税务事宜</div>
            </div>
            <template #foot>
                <veui-button ui="l primary" @click="closeConfirmDialog">
                    我知道了
                </veui-button>
            </template>
        </veui-dialog>

        <!-- 未同意确认二次弹窗 -->
        <veui-dialog
            title="未确认税务代办服务说明"
            :closable="true"
            :open="showCancelDialog"
            overlay-class="tax-dialog"
            @cancel="closeCancelDialog"
        >
            <div class="tax-dialog-content">
                <div>如未确认《税务代办服务说明》，平台将无法为您代办增值税及附加税的计算、申报、缴纳等税务事宜。若7日内未确认您的付费咨询将自动变更为免费，关闭后可前往首页查看</div>
            </div>
            <template #foot>
                <veui-button ui="l primary" @click="clickBackToConfirm">
                    返回确认
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
// 税务确认弹窗
import {Dialog, Button} from 'veui';
import {mapActions} from 'vuex';

export default {
    name: 'taxConfirmDialog',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    data() {
        return {
            showTaxDialog: false,
            showConfirmDialog: false,
            showCancelDialog: false,
            isSubmit: false
        };
    },
    props: {
        isConsultSet: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        ...mapActions({
            getUserInfoNew: 'lawStore/getUserInfoNew'
        }),
        clickAgree() {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            const params = {
                is_tax_agency: 1
            };
            // 请求授权接口，授权成功刷新接口
            this.$http.get('/bp/api/user/tax', {
                params
            }).then(res => {
                if (res?.code !== '0') {
                    return;
                }
                this.showTaxDialog = false;
                this.getUserInfoNew();
                if (!this.isConsultSet) {
                    this.showConfirmDialog = true;
                }
                this.$emit('agree');
            }).catch(err => {}).finally(() => {
                this.isSubmit = false;
            });
            this.$wywLog.send({
                serverId: 20016,
                action: 'click',
                area: 'tax-dialog'
            });
        },
        closeTaxDialog() {
            this.$wywLog.send({
                serverId: 20016,
                action: 'click',
                area: 'tax-dialog-close'
            });
            this.showTaxDialog = false;
            if (this.isConsultSet) {
                return;
            }
            this.showCancelDialog = true;
        },
        closeConfirmDialog() {
            this.showConfirmDialog = false;
        },
        closeCancelDialog() {
            this.$wywLog.send({
                serverId: 20016,
                action: 'click',
                area: 'tax-cancel-dialog-close'
            });
            this.showCancelDialog = false;
        },
        open() {
            this.showTaxDialog = true;
            this.$wywLog.send({
                serverId: 20016,
                action: 'show',
                area: 'tax-dialog'
            });
        },
        clickBackToConfirm() {
            this.$wywLog.send({
                serverId: 20016,
                action: 'click',
                area: 'tax-back-to-confirm'
            });
            this.showCancelDialog = false;
            this.open();
        }
    }
};
</script>

<style lang='less'>
.tax-dialog {
    .veui-dialog-content {
        width: 420px;
        border-radius: 8px;

        .veui-dialog-content-head-title {
            line-height: 1;
        }

        .veui-dialog-content-head-close {
            font-size: 14px;
        }

        .veui-dialog-content-foot {
            display: flex;
            justify-content: center;
            padding-top: 24px;

            .veui-button {
                width: 181px;
                height: 40px;
                border-radius: 5px;
                font-weight: 500;
                font-style: Medium;
                font-size: 16px;
            }
        }
    }
}
</style>
<style lang="less" scoped>
.tax-dialog-content {
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
    color: #1e1f24;

    p {
        line-height: 24px;
        font-size: 16px;
        margin-bottom: 8px;
        color: #1e1f24;
    }

    .tips {
        color: #848691;
        font-size: 13px;
        line-height: 19px;
        margin-top: 21px;
    }
}
</style>
